import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IOdbBillProductSplit } from '@dch/billing-business-logic';

@Component({
  selector: 'my-bill-odb-product-split-header',
  templateUrl: './odb-product-split-header.component.html',
  standalone: false,
})
export class OdbProductSplitHeaderComponent {
  @Input() productSplit: Array<IOdbBillProductSplit>;
  @Input() selectedProductSplitIdentifier: string;
  @Output() handleChangeOfSelectedItendifier: EventEmitter<string> =
    new EventEmitter();

  changeOfProductSplitIdentifier(selectedProductSplitIdentifier: string) {
    this.handleChangeOfSelectedItendifier.emit(selectedProductSplitIdentifier);
  }
}
